import React from 'react';
import { map } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { CallTrendsDurationReports } from 'ui/containers/CallTrendsDurationReports';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { trendsReports as TrendsReports } from 'ui/views/widgets/trendsReports';
 *
 * // render
 * <TrendsReports propName='propValue'/>
 */

 // widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.CALL_TRENDS_DURATION_REPORTS ]: CallTrendsDurationReports
};

const trendsReportsSuccess = ( props ) => {
    return (
        <div className='ui-trends-reports'>
            {
                map( props.widgets, widget => {

                    // get widget view
                    const WidgetView = WIDGET_VIEWS[ widget.name ];
        
                    // widget class name
                    const widgetClassName = classnames( 'ui-trends-reports__widget', `ui-trends-reports__widget--name-${ widget.name }` );
        
                    return (
                        <div key={ widget.name } className={ widgetClassName }>
                            <WidgetView widget={ widget } />
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
trendsReportsSuccess.displayName = 'trendsReportsSuccess';

// set default props
trendsReportsSuccess.defaultProps = {};

// prop types
trendsReportsSuccess.propTypes = {};


export const trendsReportsPreloader = () => {
    return (
        <div className='ui-trends-reports'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
trendsReportsPreloader.displayName = 'trendsReportsPreloader';

// set default props
trendsReportsPreloader.defaultProps = {};

// prop types
trendsReportsPreloader.propTypes = {};

/************************************************************** */

export const trendsReports = withNetworkState( trendsReportsPreloader, trendsReportsSuccess );
